import script from "./BannerCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerCarousel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__